// extracted by mini-css-extract-plugin
export default {"-large":"BBlkg4OKjdHoGxbrzkLw","divider":"Dr0HzXhz7q4VLaEcgGTg"};